import {handleEmailSending} from "../../helpers/email/emailHelper.ts";
import {fromCharCode} from "@opay/lib-core-js";

const OfficerContactEmail = () => {

    const name = fromCharCode(105, 110, 102, 111);
    const domain = fromCharCode(112, 114, 105, 118, 97, 99, 121, 112, 97, 114, 116, 110, 101, 114, 115, 46, 108, 116);

    return (
        <>
            <a className="contact-by-email" href='#' onClick={(e) => handleEmailSending(e, name, domain)}>
                {`${fromCharCode(105, 110, 102, 111, 64, 112, 114, 105, 118, 97, 99, 121, 112, 97, 114, 116, 110, 101, 114, 115, 46, 108, 116)}`}
            </a>
        </>
    )
}

export default OfficerContactEmail;
